var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pot-1-print-sheet-header"},[_c('r-text',{attrs:{"size":16,"weight":700}},[_vm._v(" Инструкция для водителей, доставляющих грузы на АГПЗ ")]),_c('img',{attrs:{"src":require("@/assets/images/logos/nipigas-logo.png"),"alt":"NIPIGAS logo"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }